<af-main-container
    [title]="(dictionaryItemId ? 'i18n_lib_breadcrumb#DictionaryId' : 'i18n_lib_breadcrumb#DictionaryAddValue') | translate:{id: dictionaryItemId}"
    [spinnerIds]="['initial']"
    [tabPathToTab]="tabPathToTab"
    [filterOneLevelNavigation]="true"
    [customLastBreadcrumb]="dictionaryItemId && ('i18n_lib_breadcrumb#DictionaryId' | translate :{id: dictionaryItemId})"
    [specialFilter]="filterPath">
    @if (form) {
        <div fxLayout="column" class="w-100 radius-16 bc-mono-white p-24 mt-24">
            <form [formGroup]="form"
                  (submit)="submit()"
                  fxLayout="column"
                  fxLayoutAlign="start start">
                <div class="grid-form-container">
                    @for (controlName of controlNames; track controlName) {
                        @if (form.get(controlName) && controlName !== 'type') {
                            <div fxLayout="column" fxLayoutAlign="start start"
                                 class="w-476">
                                <div
                                    class="t5 c-primary-gray-600">{{ ('i18n_af_labelDictionary#' + controlName) | translate }} {{ form.get(controlName).hasValidator(Validators.required) ? '*' : '' }}
                                </div>
                                <mat-form-field class="w-100 mt-4"
                                                [class.value-not-empty]="!!form.get(controlName).value">
                                    <input matInput
                                           [placeholder]="('i18n_af_placeholderDictionary#' + controlName) | translate"
                                           [formControlName]="controlName"/>
                                    @if (form.get(controlName).hasError('required')) {
                                        <mat-error
                                            class="c-secondary-red-900">
                                            {{ 'i18n_af_fieldValidationRequired' | translate }}
                                        </mat-error>
                                    }
                                </mat-form-field>
                            </div>
                        }
                        @if (form.get(controlName) && controlName === 'type') {
                            <af-dictionary-selector
                                [control]="form.controls.type"
                                [predefinedValue]="dictionaryName"
                                [disabled]="dictionaryName !== 'reference'"
                                label="i18n_af_labelDictionary#type"
                                placeholder="i18n_af_placeholderDictionary#type"
                                dictionaryName="reference"/>
                        }
                    }
                </div>
                <div fxLayout="row" fxLayoutAlign="start center" class="mt-40">
                    <ui-kit-button spinnerId="submit"
                                   [disabled]="form.invalid"
                                   [label]="'i18n_af_buttonSave' | translate"/>
                    <ui-kit-button class="ml-16"
                                   color="accent"
                                   buttonType="button"
                                   type="text"
                                   (clickListener)="navigateBack()"
                                   [label]="'i18n_af_buttonCancel' | translate"/>
                </div>
            </form>
        </div>
    }
</af-main-container>
